import { c as _c } from "react/compiler-runtime";
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import useSWR from 'swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { UserInterface } from 'shared/types/user-interface';
import { DASHBOARD_USER_DATA_API } from '../constants/api';
export const useDashboardUser = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get,
      stopErrorPropagation: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  const {
    data: dashboardUser,
    mutate: dashboardMutate
  } = useSWR(DASHBOARD_USER_DATA_API, fetcher);
  let t1;
  let t2;
  if ($[1] !== dashboardUser) {
    t1 = () => {
      if (dashboardUser) {
        Sentry.setUser({
          id: dashboardUser.id,
          username: `${dashboardUser.firstName} ${dashboardUser.lastName}`
        });
      }
    };
    t2 = [dashboardUser];
    $[1] = dashboardUser;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  const isDisabled = dashboardUser ? !dashboardUser.impersonator && !dashboardUser.enabled : false;
  let t3;
  if ($[4] !== dashboardMutate || $[5] !== dashboardUser || $[6] !== isDisabled) {
    t3 = {
      dashboardUser,
      dashboardMutate,
      isDisabled
    };
    $[4] = dashboardMutate;
    $[5] = dashboardUser;
    $[6] = isDisabled;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};